import { Injectable } from "@angular/core";
import { BucketGridMetaModel } from "common/models/page-models/applicants/bucket/bucket-grid-meta.model";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { SystemService } from "common/services/core-services/system.service";
import { BucketDataService } from "common/services/data-services/admin/applicants-dashboard/bucket-data.service";
import { BucketListingModel, BucketModel } from "common/models/page-models/applicants/bucket/bucket-grid.model";
import { GridWidgetService } from "../grid-widget.services";
import { ApplicantStudentStatusUpdate } from "common/services/data-services/admin/applicants-dashboard/applicant-StudentStatusUpdate.service";
import { SmMetaModel } from "common/models/utility-models/meta-model";
import { DepartmentListDataService } from "common/services/data-services/custom-service/department-list-service";
import { stateListDataService } from "common/services/data-services/custom-service/stateList-service.service";
import { zoneListDataService } from "common/services/data-services/custom-service/zoneList-service";

@Injectable({
  providedIn: 'root',
})
export class BucketWidgetService extends GridWidgetService<BucketModel,BucketListingModel> {
  constructor(
    public override ds: BucketDataService,
    protected ss: SystemService,
    protected applicatstatusupdate:ApplicantStudentStatusUpdate,
    protected stateList: stateListDataService,
    protected department: DepartmentListDataService,
    protected zoneList: zoneListDataService,
  ) {
    super(ds);
  }
  

  getMetaModel(): MetaModel {
    const meta = new BucketGridMetaModel();
    return meta.getMetaModel();
  }

  override prepareMetaModel(
    dataModel: DataModel,
    metaModel: SmMetaModel,
    routeData: WidgetModel
  ): Promise<SmMetaModel> {
    return new Promise<SmMetaModel>((resolve, reject) => {
      this.stateList.postData('').then((data) => {
        metaModel.properties.filters.selectedState.values = data.details
        metaModel.properties.stateFilerConstant = data.details;
      });
      this.department.postData('').then((data) => {
        metaModel.properties.filters.selectedBranch.values = data.details
      });
      this.zoneList.postData('').then((data) => {
        metaModel.properties.filters.selectedRegion.values = data.details
      });
      
      resolve(metaModel);
    });
  }


  applicantStudentStatusUpdate()
  {
    this.applicatstatusupdate.postData({}).then((data) => {
    });
  }
  

  

}
